import { Button, HStack, Text } from '@chakra-ui/react';

export interface IRemoveAddProps {
  onChange: (value: number) => void;
  value: number;
  size?: 'sm' | 'md' | 'lg';
  minValue?: number;
  maxValue?: number;
}

export const RemoveAdd = ({
  onChange,
  value,
  size = 'md',
  minValue = 1,
  maxValue,
}: IRemoveAddProps) => {
  const increment = () => {
    onChange(value + 1);
  };
  const decrement = () => {
    if (value > minValue) {
      onChange(Math.max(minValue, value - 1));
    }
  };

  return (
    <HStack
      spacing={0}
      borderRadius={8}
      overflow="hidden"
      boxShadow="md"
      bg="neutral.100"
      p={0.5}
    >
      <Button
        onClick={decrement}
        variant="ghost"
        border="1px solid"
        borderRadius={6}
        borderColor="neutral.200"
        bg="white"
        size={size}
        w={10}
        _hover={{ bg: 'neutral.50' }}
        isDisabled={value === minValue}
      >
        -
      </Button>
      <Text
        fontWeight="bold"
        minW="40px"
        textAlign="center"
        color="neutral.700"
      >
        {value}
      </Text>
      <Button
        onClick={increment}
        variant="ghost"
        border="1px solid"
        borderRadius={6}
        borderColor="neutral.200"
        bg="white"
        size={size}
        w={10}
        _hover={{ bg: 'neutral.50' }}
        isDisabled={value === maxValue}
      >
        +
      </Button>
    </HStack>
  );
};
